const validator = require('ui-validator');
const UiMoney = require('ui-money');

const isUiMoney = validator.createValidator((opions, value) => {
  if (!value) {
    return undefined;
  }

  const parsed = new UiMoney(value);

  if (isNaN(parsed.getValue())) {
    return 'Please enter a valid dollar amount';
  }

  return undefined;
});

const v = validator.validators;
const validations = {
  income: {
    required: v.required({ message: 'The income is required' }),
    dollarAmountRange: v.dollarAmountRange({
      min: 0,
      max: 9999999,
      underMinMessage: 'The income you have entered is negative',
      overMaxMessage: 'The income you have entered is above the maximum income allowed',
      invalidMessage: 'The income you have entered is not valid',
    }),
    isUiMoney: isUiMoney(),
  },
};

export default validations;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/Income/Income.scss');